import { ApolloLink } from "@apollo/client";
import { snapSSOTokenStorage } from "@snapchat/sso-auth";

import { isPreProd } from "../../shared/constants";
import { APOLLO_OPERATION_NAME_HEADER, PRE_PROD_TAG, SNAP_ROUTE_TAG } from "../../shared/infrastructure";
export const authLink = new ApolloLink((operation, forward) => {
    const token = snapSSOTokenStorage.getToken();

    operation.setContext({
        headers: {
            Authorization: token ? `Bearer ${token}` : "",
            ...(isPreProd() && { [SNAP_ROUTE_TAG]: PRE_PROD_TAG }),
            [APOLLO_OPERATION_NAME_HEADER]: operation.operationName || "", // needed for apollo v4 CSRF protection
        },
    });

    return forward(operation);
});
